export default __webpack_public_path__ + "static/media/watchdog-6.03913168.png";